import React from "react";
import { exact, number, string } from "prop-types";
import styles from "./RegionTrainingPlansRow.module.styl";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import { percentageLevels } from "utils/indicator/indicatorSettings.js";
import { chartOptions, smallChartWidth } from "utils/chart/chartOptions";

export default function RegionTrainingPlansRow({ schoolTrainingPlan, regionId }) {
    const indicatorStyle = percentageLevels.indicatorColor(schoolTrainingPlan.trainingPlanFilling);
    const options = chartOptions(indicatorStyle);
    const series = [schoolTrainingPlan.trainingPlanFilling];

    return (
        <div className={styles.row}>
            <Link
                to={`/training-plans/region/${regionId}/school/${schoolTrainingPlan.schoolId}`}
                className={styles.schoolName}
            >
                {schoolTrainingPlan.schoolName}
            </Link>
            <div className={styles.municipalityName}>{schoolTrainingPlan.municipalityName}</div>
            <div className={styles.chart}>
                <Chart options={options} series={series} type="radialBar" width={smallChartWidth} />
            </div>
        </div>
    );
}

RegionTrainingPlansRow.propTypes = {
    regionId: number.isRequired,
    schoolTrainingPlan: exact({
        schoolId: number.isRequired,
        schoolName: string.isRequired,
        municipalityName: string,
        trainingPlanFilling: number.isRequired,
    }),
};
